module.exports = __webpack_public_path__ + "static/coach-hire-services-sm-mobile-3efd6881ef00b1d157849603739d85a2.jpg";